import { createTermTagManager } from '../../utils/createTermTagManager';

export const withoutDepositTagManager = createTermTagManager({
  jsonQueryKey: 'zalog',
  label: 'Без залога',
  id: 'withoutDeposit',
});
